import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { SERVER_URL } from '@/env-vars'
import { useAuthFromStorage } from '@/hooks/useAuthStorage'
import { toast } from 'sonner'
import { SaveVideoType } from '@/store/types'
import { errors } from '@/i18n/errors'
import { analytics } from '@/lib/analytics'

export function useSaveVideo() {
	const { authToken } = useAuthFromStorage()

	return useMutation({
		mutationKey: ['add-to-saved-videos'],
		mutationFn: async (videoData: SaveVideoType) => {
			const response = await axios.post(
				`${SERVER_URL}/favorites/add`,
				videoData,
				{
					headers: { Authorization: `Bearer ${authToken}` },
				},
			)
			return response.data
		},
		onSuccess: (_, videoData) => {
			analytics.videoSaved(videoData.title)
		},
		onError: () => {
			toast.error(errors.SAVE_VIDEO_ERROR)
		},
	})
}
